<template>
  <div v-if="$store.getters.user != null" class="container">
    <div class="row">
      <div class="col">
        <h4 class="my-2">Archive</h4>
      </div>
    </div>
    <div
      class="row text-left"
      v-for="organization in organizations
        .filter(o => o.Organization_Type_Id == 3)
        .slice()
        .sort($orderByName)"
      :key="organization.Organization_Id"
    >
      <div class="col">
        <div class="row underlined">
          <div class="col">
            <h4 class="my-2">{{ organization.Name }}</h4>
          </div>
        </div>
        <div
          v-for="schoolGroup in organizations
            .filter(
              o =>
                o.Organization_Type_Id == 6 || o.Organization_Type_Id == 7 &&
                o.Parent_Organization_Id == organization.Organization_Id
            )
            .slice()
            .sort($orderByName)"
          :key="schoolGroup.Organization_Id"
        >
          <div class="row mb-4" v-if="schoolGroup.Archived_Subjects.length > 0">
            <div class="col">
              <div class="row">
                <div class="col">
                  <h5 class="mb-4 mt-2">{{ schoolGroup.Name }}</h5>
                </div>
              </div>
              <div
                v-for="subject in schoolGroup.Archived_Subjects"
                :key="subject.Subject_Id"
              >
                <div class="card text-left mb-2">
                  <div class="card-header">
                    <div class="row">
                      <div class="col-auto">
                        <h5 class="mb-0">{{ subject.Title }}</h5>
                      </div>
                      <div v-if="!subject.Is_Archived" class="col-auto">
                        <p class="mb-0 text-secondary">
                          This subject is not archived, but unit or student data
                          in this subject has been archived
                        </p>
                      </div>
                      <div
                        v-if="subject.Is_Archived && canEditSubject(subject)"
                      >
                        <button
                          v-if="canEditSubject(subject)"
                          class="btn btn-sm btn-primary py-0 mb-1"
                          v-on:click="unarchiveSubject(subject)"
                        >
                          Unarchive
                        </button>
                      </div>
                      <div
                        class="col-auto"
                        v-if="subject.Is_Archived && canEditSubject(subject)"
                      >
                        <button
                          class="btn btn-sm btn-danger py-0 mb-1"
                          v-on:click="deleteSubject(subject)"
                        >
                          Delete Forever
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div
                      class="row mb-1"
                      v-for="unit in subject.Archived_Units.slice().sort(
                        $orderByTitle
                      )"
                      :key="unit.Unit_Id"
                    >
                      <div class="col">
                        <div class="row">
                          <div class="col-auto px-0">
                            <i
                              class="material-icons pointer pt-1"
                              v-bind:id="unit.Unit_Id + 'unitToggleIcon'"
                              data-toggle="collapse"
                              v-bind:href="'#unitStudents' + unit.Unit_Id"
                              role="button"
                              aria-expanded="false"
                              v-on:click="
                                $updateToggleIcon(
                                  '#' + unit.Unit_Id + 'unitToggleIcon'
                                )
                              "
                              >add</i
                            >
                          </div>
                          <div class="col-auto pl-1 pr-2 pt-1">
                            <p>{{ unit.Title }}</p>
                          </div>
                          <div
                            class="col-auto pl-0"
                            v-if="unit.Is_Archived && canEditSubject(subject)"
                          >
                            <button
                              class="btn btn-sm btn-primary py-0"
                              v-on:click="unarchiveUnit(unit)"
                            >
                              Unarchive
                            </button>
                          </div>
                          <div
                            class="col-auto pl-0"
                            v-if="unit.Is_Archived && canEditSubject(subject)"
                          >
                            <button
                              class="btn btn-sm btn-danger py-0"
                              v-on:click="deleteUnit(unit)"
                            >
                              Delete Forever
                            </button>
                          </div>
                          <div
                            class="col-auto pl-0 pt-1"
                            v-if="!unit.Is_Archived"
                          >
                            <p class="text-secondary">
                              This unit is not archived, but student data in
                              this unit has been archived
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div
                            class="col container collapse ml-4"
                            v-bind:id="'unitStudents' + unit.Unit_Id"
                          >
                            <div class="row">
                              <div
                                class="mb-1 col"
                                style="background-color:gray; height:1px; width:100%"
                              />
                            </div>
                            <div
                              class="row"
                              v-for="student in students.filter(s =>
                                s.Archived_Student_Units.some(
                                  u => u.Unit.Unit_Id == unit.Unit_Id
                                )
                              )"
                              :key="
                                'student' +
                                  student.Student_Id +
                                  'unit' +
                                  unit.Unit_Id
                              "
                            >
                              <div class="col">
                                <div class="row">
                                  <div class="col-auto pr-0">
                                    <i
                                      class="material-icons pointer"
                                      v-bind:id="
                                        'studentToggleIcon' +
                                          student.Student_Id +
                                          'unit' +
                                          unit.Unit_Id
                                      "
                                      data-toggle="collapse"
                                      v-bind:href="
                                        '#studentDetails' +
                                          student.Student_Id +
                                          'unit' +
                                          unit.Unit_Id
                                      "
                                      role="button"
                                      aria-expanded="false"
                                      v-on:click="viewData(student, unit)"
                                      >add</i
                                    >
                                  </div>
                                  <div class="col-auto pr-0">
                                    <p class="mb-1">{{ student.Name }}</p>
                                  </div>
                                  <div class="col-auto pr-0">
                                    <button
                                      class="btn btn-sm btn-primary py-0"
                                      v-on:click="
                                        unarchiveStudentUnit(student, unit)
                                      "
                                    >
                                      Unarchive
                                    </button>
                                  </div>
                                  <div class="col-auto">
                                    <button
                                      class="btn btn-sm btn-danger py-0"
                                      v-on:click="
                                        deleteStudentUnit(student, unit)
                                      "
                                    >
                                      Delete Forever
                                    </button>
                                  </div>
                                </div>
                                <div
                                  class="row container py-0 collapse"
                                  v-bind:id="
                                    'studentDetails' +
                                      student.Student_Id +
                                      'unit' +
                                      unit.Unit_Id
                                  "
                                >
                                  <div class="col">
                                    <div class="row">
                                      <div
                                        class="mb-1 col"
                                        style="background-color:gray; height:1px; width:100%"
                                      />
                                    </div>
                                    <div class="row">
                                      <StudentUnitScores
                                        v-if="
                                          studentUnitScoreTemplates.some(
                                            suct =>
                                              suct.studentId ==
                                                student.Student_Id &&
                                              suct.unitId == unit.Unit_Id
                                          )
                                        "
                                        v-bind:Student="student"
                                        v-bind:ScoreTemplate="
                                          studentUnitScoreTemplates.find(
                                            suct =>
                                              suct.studentId ==
                                                student.Student_Id &&
                                              suct.unitId == unit.Unit_Id
                                          ).scoreTemplate
                                        "
                                        v-bind:Scores="
                                          studentUnitScores.find(
                                            sus =>
                                              sus.studentId ==
                                                student.Student_Id &&
                                              sus.unitId == unit.Unit_Id
                                          ).scores
                                        "
                                        v-bind:Unit="unit"
                                        v-bind:HideStudentName="true"
                                        v-bind:IsArchived="true"
                                        @unarchive="
                                          unarchiveStudentUnit(student, unit)
                                        "
                                        @delete-unit="
                                          deleteStudentUnit(student, unit)
                                        "
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          !organizations.some(
            o =>
              o.Organization_Type_Id == 6 || o.Organization_Type_Id == 7 &&
              o.Parent_Organization_Id == organization.Organization_Id
          )
        "
      >
        <p class="my-4">
          You have no groups. Go to your organization or account settings
          to create a group in order to create/manage subjects.
        </p>
      </div>
    </div>
    <ConfirmDeleteModal
      v-bind:DeletingTitle="deletingTitle"
      @confirm-delete="confirmDelete"
    />
  </div>
</template>

<script>
import $ from "jquery";
import StudentUnitScores from "@/components/Score/StudentUnitScores.vue";
import ConfirmDeleteModal from "@/modals/ConfirmDeleteModal.vue";

export default {
  components: {
    StudentUnitScores,
    ConfirmDeleteModal
  },
  watch: {
    "$store.getters.user": async function() {
      this.loadSubjects();
    }
  },
  data() {
    return {
      organizations: [],
      students: [],
      scoreTemplates: [],
      studentUnitScoreTemplates: [],
      studentUnitScores: [],
      studentUnitToDelete: null,
      unitToDelete: null,
      subjectToDelete: null,
      deletingTitle: ""
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    await this.loadSubjects();
  },
  methods: {
    async loadSubjects(scrollToSubject = -1) {
      var view = this;
      if (view.$store.getters.user != null) {
        view.students = await view.$getMyArchivedSubjectStudents();
        view.scoreTemplates = (await this.$getMyScoreTemplates()).filter(
          s => s.Score_Template_Type_Id == 1
        );
        view.organizations = await view.$getMyArchivedSubjectOrganizations(
          true
        );
        if (scrollToSubject != -1) {
          this.scrollToSubject(scrollToSubject);
        }
        this.$store.commit("updateLoading", false);
      }
    },
    async subjectStudentsUpdated(subjectId) {
      await this.loadSubjects(subjectId);
    },
    getOrganizationStudents(subject) {
      return this.organizations.find(
        o => o.Organization_Id == subject.Organization_Id
      ).Students;
    },
    canEditSubject(subject) {
      return this.$canManageSubject(
        this.$store.getters.user.Permissions,
        subject.Subject_Id,
        subject.Organization_Id
      );
    },
    async unarchiveSubject(subject) {
      this.$store.commit("updateLoading", true);
      await this.$unarchiveSubject(subject.Subject_Id);
      var organizationSubjectIndex = this.organizations.findIndex(o =>
        o.Archived_Subjects.some(s => s.Subject_Id == subject.Subject_Id)
      );
      this.organizations[
        organizationSubjectIndex
      ].Archived_Subjects = this.organizations[
        organizationSubjectIndex
      ].Archived_Subjects.filter(s => s.Subject_Id != subject.Subject_Id);
      this.$store.commit("updateLoading", false);
    },
    async unarchiveUnit(unit) {
      this.$store.commit("updateLoading", true);
      await this.$unarchiveUnit(unit.Unit_Id);
      var organizationIndex = this.organizations.findIndex(o =>
        o.Archived_Subjects.some(s =>
          s.Archived_Units.some(u => u.Unit_Id == unit.Unit_Id)
        )
      );
      var subjectIndex = this.organizations[
        organizationIndex
      ].Archived_Subjects.findIndex(s =>
        s.Archived_Units.some(u => u.Unit_Id == unit.Unit_Id)
      );
      this.organizations[organizationIndex].Archived_Subjects[
        subjectIndex
      ].Archived_Units = this.organizations[
        organizationIndex
      ].Archived_Subjects[subjectIndex].Archived_Units.filter(
        u => u.Unit_Id != unit.Unit_Id
      );
      this.organizations[organizationIndex].Archived_Subjects[
        subjectIndex
      ].Is_Archived = false;
      if (
        this.organizations[organizationIndex].Archived_Subjects[subjectIndex]
          .Archived_Units.length == 0
      ) {
        var subjectId = this.organizations[organizationIndex].Archived_Subjects[
          subjectIndex
        ].Subject_Id;
        this.organizations[
          organizationIndex
        ].Archived_Subjects = this.organizations[
          organizationIndex
        ].Archived_Subjects.filter(s => s.Subject_Id != subjectId);
      }
      this.$store.commit("updateLoading", false);
    },
    async unarchiveStudentUnit(student, unit) {
      this.$store.commit("updateLoading", true);
      var studentUnit = student.Archived_Student_Units.find(
        u => u.Unit.Unit_Id == unit.Unit_Id
      );
      await this.$unarchiveStudentUnits([studentUnit.Student_Unit_Id]);
      this.studentUnitScoreTemplates.filter(
        t => t.studentId != student.Student_Id && t.unitId != unit.Unit_Id
      );
      this.studentUnitScores.filter(
        s => s.studentId != student.Student_Id && s.unitId != unit.Unit_Id
      );
      var studentIndex = this.students.findIndex(
        s => s.Student_Id == student.Student_Id
      );

      this.students[studentIndex].Archived_Student_Units = this.students[
        studentIndex
      ].Archived_Student_Units.filter(
        u => u.Student_Unit_Id != studentUnit.Student_Unit_Id
      );

      var organizationIndex = this.organizations.findIndex(o =>
        o.Archived_Subjects.some(s =>
          s.Archived_Units.some(u => u.Unit_Id == unit.Unit_Id)
        )
      );
      var subjectIndex = this.organizations[
        organizationIndex
      ].Archived_Subjects.findIndex(s =>
        s.Archived_Units.some(u => u.Unit_Id == unit.Unit_Id)
      );
      var unitIndex = this.organizations[organizationIndex].Archived_Subjects[
        subjectIndex
      ].Archived_Units.findIndex(u => u.Unit_Id == unit.Unit_Id);
      this.organizations[organizationIndex].Archived_Subjects[
        subjectIndex
      ].Archived_Units[unitIndex].Is_Archived = false;
      //if no more students in that unit remove the unit
      if (
        !this.students.some(s =>
          s.Archived_Student_Units.some(su => su.Unit.Unit_Id == unit.Unit_Id)
        )
      ) {
        this.organizations[organizationIndex].Archived_Subjects[
          subjectIndex
        ].Archived_Units = this.organizations[
          organizationIndex
        ].Archived_Subjects[subjectIndex].Archived_Units.filter(
          u => u.Unit_Id != unit.Unit_Id
        );
      }
      //if no more units in the subject remove the subject
      this.organizations[organizationIndex].Archived_Subjects[
        subjectIndex
      ].Is_Archived = false;
      if (
        this.organizations[organizationIndex].Archived_Subjects[subjectIndex]
          .Archived_Units.length == 0
      ) {
        var subjectId = this.organizations[organizationIndex].Archived_Subjects[
          subjectIndex
        ].Subject_Id;
        this.organizations[
          organizationIndex
        ].Archived_Subjects = this.organizations[
          organizationIndex
        ].Archived_Subjects.filter(s => s.Subject_Id != subjectId);
      }
      this.$store.commit("updateLoading", false);
    },
    async viewData(student, unit) {
      if (
        !this.studentUnitScores.some(
          sus =>
            sus.studentId == student.Student_Id && sus.unitId == unit.Unit_Id
        )
      ) {
        this.$store.commit("updateLoading", true);
        this.studentUnitScores.push({
          studentId: student.Student_Id,
          unitId: unit.Unit_Id,
          scores: await this.$getStudentUnitScores(
            student.Archived_Student_Units.find(
              su => su.Unit.Unit_Id == unit.Unit_Id
            ).Student_Unit_Id
          )
        });
        this.studentUnitScoreTemplates.push({
          studentId: student.Student_Id,
          unitId: unit.Unit_Id,
          scoreTemplate: this.scoreTemplates.find(
            t => t.Score_Template_Id == unit.Score_Template_Id
          )
        });
        this.$store.commit("updateLoading", false);
      }
      this.$updateToggleIcon(
        "#studentToggleIcon" + student.Student_Id + "unit" + unit.Unit_Id
      );
    },
    deleteStudentUnit(student, unit) {
      this.unitToDelete = null;
      this.subjectToDelete = null;
      this.deletingTitle = student.Name + " - " + unit.Title;
      this.studentUnitToDelete = student.Archived_Student_Units.find(
        u => u.Unit.Unit_Id == unit.Unit_Id
      );
      $("#confirmDeleteModal").modal("show");
    },
    deleteUnit(unit) {
      this.unitToDelete = unit;
      this.subjectToDelete = null;
      this.studentUnitToDelete = null;
      this.deletingTitle = unit.Title;
      $("#confirmDeleteModal").modal("show");
    },
    deleteSubject(subject) {
      this.studentUnitToDelete = null;
      this.unitToDelete = null;
      this.subjectToDelete = subject;
      this.deletingTitle = subject.Title;
      $("#confirmDeleteModal").modal("show");
    },
    async confirmDelete() {
      $("#confirmDeleteModal").modal("hide");
      this.$store.commit("updateLoading", true);
      if (this.studentUnitToDelete != null) {
        await this.$deleteStudentUnits([
          this.studentUnitToDelete.Student_Unit_Id
        ]);
        this.studentUnitScoreTemplates.filter(
          t =>
            t.studentId != this.studentUnitToDelete.Student_Id &&
            t.unitId != this.studentUnitToDelete.Unit.Unit_Id
        );
        this.studentUnitScores.filter(
          s =>
            s.studentId != this.studentUnitToDelete.Student_Id &&
            s.unitId != this.studentUnitToDelete.Unit.Unit_Id
        );
        var studentIndex = this.students.findIndex(
          s => s.Student_Id == this.studentUnitToDelete.Student_Id
        );
        this.students[studentIndex].Archived_Student_Units = this.students[
          studentIndex
        ].Archived_Student_Units.filter(
          u => u.Student_Unit_Id != this.studentUnitToDelete.Student_Unit_Id
        );
      }
      if (this.unitToDelete != null) {
        await this.$deleteUnit(this.unitToDelete.Unit_Id);
        var organizationIndex = this.organizations.findIndex(o =>
          o.Archived_Subjects.some(s =>
            s.Archived_Units.some(u => u.Unit_Id == this.unitToDelete.Unit_Id)
          )
        );
        var subjectIndex = this.organizations[
          organizationIndex
        ].Archived_Subjects.findIndex(s =>
          s.Archived_Units.some(u => u.Unit_Id == this.unitToDelete.Unit_Id)
        );
        this.organizations[organizationIndex].Archived_Subjects[
          subjectIndex
        ].Archived_Units = this.organizations[
          organizationIndex
        ].Archived_Subjects[subjectIndex].Archived_Units.filter(
          u => u.Unit_Id != this.unitToDelete.Unit_Id
        );
      }
      if (this.subjectToDelete != null) {
        await this.$deleteSubject(this.subjectToDelete.Subject_Id);
        var organizationSubjectIndex = this.organizations.findIndex(o =>
          o.Archived_Subjects.some(
            s => s.Subject_Id == this.subjectToDelete.Subject_Id
          )
        );
        this.organizations[
          organizationSubjectIndex
        ].Archived_Subjects = this.organizations[
          organizationSubjectIndex
        ].Archived_Subjects.filter(
          s => s.Subject_Id != this.subjectToDelete.Subject_Id
        );
      }
      this.unitToDelete = null;
      this.subjectToDelete = null;
      this.studentUnitToDelete = null;
      this.$store.commit("updateLoading", false);
    }
  }
};
</script>
